import { render, staticRenderFns } from "./team.match.create.vue?vue&type=template&id=612cbdd2&scoped=true&"
import script from "./team.match.create.vue?vue&type=script&lang=js&"
export * from "./team.match.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612cbdd2",
  null
  
)

export default component.exports